'use client';
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Link from 'next/link';
import { ChevronDown, MessageCircle } from 'lucide-react';
import { useLanguage } from '@/components/LanguageProvider';

function FaqItem({ q, a }: { q: string, a: string }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="bg-[#161616] rounded-[16px] md:rounded-[20px] border border-white/5 overflow-hidden mb-3 w-full">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex justify-between items-center p-5 md:p-6 md:px-8 text-left cursor-pointer transition-colors hover:bg-white/[0.02]">
        <span className="font-semibold text-base md:text-lg text-white pr-4">{q}</span>
        <motion.div animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.3, ease: "circOut" }} className="text-white/50 shrink-0"><ChevronDown size={20} /></motion.div>
      </button>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div key="content" initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ height: { duration: 0.3 } }} style={{ overflow: "hidden" }}>
            <div className="px-5 md:px-8 pb-5 md:pb-8 text-[#aaaaaa] font-medium text-sm md:text-[15px] leading-relaxed">{a}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default function FAQSection() {
  const { t } = useLanguage();
  const tl = t.landing;

  return (
    <section className="py-20 md:py-24 w-full px-4 sm:px-6 max-w-3xl mx-auto bg-transparent relative z-20">
        <h2 className="font-mc text-3xl md:text-5xl uppercase mb-10 md:mb-12 text-center text-white">{tl.faq.title}</h2>
        <div className="space-y-3 w-full">
        {tl.faq.items.map((item, idx) => (
            <FaqItem key={idx} q={item.q} a={item.a} />
        ))}
        </div>

        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "0px 0px -50px 0px" }} transition={{ duration: 0.6, ease: "easeOut" }} className="mt-10 md:mt-12 text-center will-change-opacity-transform w-full">
        <Link href="https://dsc.gg/rplands" target="_blank" className="inline-flex items-center gap-2 text-[#7a93ff] font-medium hover:text-white transition-colors group outline-none focus:outline-none cursor-pointer">
            <MessageCircle size={20} className="group-hover:scale-110 transition-transform"/>
            {tl.faq.askDiscord}
        </Link>
        </motion.div>
    </section>
  );
}